import { useSelector } from 'react-redux';
import { translate } from '../../../lib/lang.helper';
import { CheckboxButton, Input } from '../../shared';
import { selectLang } from '../../../store/ui/ui.selector';
import { numToStr } from '../../../lib/common.helpers';

interface Props {
  className?: string;
  label: string;
  min?: number | null;
  max?: number | null;
  unit?: string;
  additionalElement?: React.ReactNode;
  onMinChange: (value: number) => void;
  onMaxChange: (value: number | null) => void;
  disabled?: boolean;
  errorMsg?: string;
}

const MinMaxInputForm = ({
  className,
  label,
  min,
  max,
  unit,
  additionalElement,
  onMinChange,
  onMaxChange,
  disabled = false,
  errorMsg,
}: Props) => {
  const lang = useSelector(selectLang);

  const toggleRange = (c: boolean) => {
    if (c) {
      onMaxChange(min || 0);
    } else {
      onMaxChange(null);
    }
  };

  return (
    <div className={className}>
      <div
        className={
          additionalElement ? 'd-flex mb-7 justify-between-align-end' : 'mb-7'
        }
      >
        <div className={additionalElement ? 'mr-17' : ''}>
          <CheckboxButton
            label={translate(lang, 'Add %s range', label.toLowerCase())}
            checked={max !== null && max !== undefined}
            onChange={e => toggleRange(e.target.checked)}
            disabled={disabled}
          />
        </div>
        {!!additionalElement && additionalElement}
      </div>
      <div className='d-flex mb-17 w-100'>
        {max === null || max === undefined ? (
          <Input
            label={label}
            type='number'
            value={numToStr(min)}
            required
            onChange={e => onMinChange(Number(e.target.value))}
            disabled={disabled}
            unit={unit}
          />
        ) : (
          <div className='d-flex justify-between w-100'>
            <div className={`w-100 mr-3 ${errorMsg ? 'invalid-form' : ''}`}>
              <Input
                label={translate(lang, 'Minimum %s', label.toLowerCase())}
                type='number'
                value={numToStr(min)}
                required
                onChange={e => onMinChange(Number(e.target.value))}
                disabled={disabled}
                unit={unit}
              />
              {errorMsg && <div className='invalid-feedback'>{errorMsg}</div>}
            </div>
            <div className='w-100 ml-3'>
              <Input
                label={translate(lang, 'Maximum %s', label.toLowerCase())}
                type='number'
                value={numToStr(max)}
                required
                onChange={e => onMaxChange(Number(e.target.value))}
                unit={unit}
                disabled={disabled}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MinMaxInputForm;
